import { render, staticRenderFns } from "./BranchSwitcher.vue?vue&type=template&id=0df7bc92&scoped=true"
import script from "./BranchSwitcher.vue?vue&type=script&lang=js"
export * from "./BranchSwitcher.vue?vue&type=script&lang=js"
import style0 from "./BranchSwitcher.vue?vue&type=style&index=0&id=0df7bc92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7bc92",
  null
  
)

export default component.exports